// Forskrift om tryggere bolighandel - Obligatoriske kontroller

export const forskriftKontroller = {
  bad: [
    {
      id: 'hulltaking_bad',
      tittel: 'Hulltaking i tilstøtende vegger',
      paragraf: '§2-18',
      beskrivelse: 'Det skal tas prøver (hulltaking) i tilstøtende vegger for å avdekke fuktskader',
      obligatorisk: true,
      konsekvens: 'Dersom ikke utført: Tilstandsrapporten er ikke godkjent',
    },
    {
      id: 'membran_kontroll',
      tittel: 'Kontroll av tetningsmembran',
      paragraf: '§2-18',
      beskrivelse: 'Visuell kontroll av membran ved sluk (der tilgjengelig)',
      obligatorisk: true,
      konsekvens: 'Må dokumenteres hvis ikke tilgjengelig for inspeksjon',
    },
    {
      id: 'hoydeforskjell_sluk',
      tittel: 'Høydeforskjell sluk til gulv',
      paragraf: 'TEK17 §13-9',
      beskrivelse: 'Kontroller at det er minst 25 mm fra topp slukrist til gulv/synlig topp membran ved dørterskel',
      obligatorisk: true,
      konsekvens: 'Dersom avvik fra TEK17-krav: TG3',
    },
    {
      id: 'fall_mot_sluk',
      tittel: 'Fall mot sluk',
      paragraf: 'TEK17 §13-9',
      beskrivelse: 'Kontroller at gulvet har tilfredsstillende fall mot sluk',
      obligatorisk: true,
      konsekvens: 'Dersom utilstrekkelig: Risiko for vannskader',
    },
  ],

  vaskerom: [
    {
      id: 'hulltaking_vaskerom',
      tittel: 'Hulltaking (hvis våtrom med membran)',
      paragraf: '§2-18',
      beskrivelse: 'Hulltaking i tilstøtende vegger hvis rommet har membran',
      obligatorisk: true,
      konsekvens: 'Obligatorisk for våtrom',
    },
    {
      id: 'sluk_vaskerom',
      tittel: 'Kontroll av sluk',
      paragraf: 'TEK17 §13-9',
      beskrivelse: 'Sluk skal være funksjonelt og ha tilstrekkelig fall',
      obligatorisk: true,
      konsekvens: 'Må dokumenteres',
    },
  ],

  wc: [
    {
      id: 'hulltaking_wc',
      tittel: 'Hulltaking i tilstøtende vegger',
      paragraf: '§2-18',
      beskrivelse: 'Hulltaking ved våtsoner',
      obligatorisk: true,
      konsekvens: 'Obligatorisk ved membran',
    },
  ],

  kjokken: [
    {
      id: 'ventilasjon_kjokken',
      tittel: 'Kontroll av ventilasjon',
      paragraf: 'TEK17 §13-8',
      beskrivelse: 'Kontroller at kjøkken har tilfredsstillende ventilasjon (avtrekk)',
      obligatorisk: true,
      konsekvens: 'Dersom utilstrekkelig eller mangler: TEK-avvik',
    },
  ],

  soverom: [
    {
      id: 'romningsvei_soverom',
      tittel: 'Rømningsvei',
      paragraf: 'TEK17 §11-7',
      beskrivelse: 'Kontroller at soverom har tilfredsstillende rømningsvei (vindu eller dør til sikker sone)',
      obligatorisk: true,
      konsekvens: 'Dersom rømningsvei mangler eller er utilstrekkelig: Alvorlig TEK-avvik = TG3',
    },
    {
      id: 'dagslys_soverom',
      tittel: 'Dagslysflate',
      paragraf: 'TEK17 §13-2',
      beskrivelse: 'Kontroller at dagslysflate er minst 1/10 av gulvflaten',
      obligatorisk: true,
      konsekvens: 'Dersom utilstrekkelig: Påvirker trivsel, helse og bomiljø. Vanligvis TG2 ved mindre avvik',
    },
  ],
};

export const hentForskriftKontroller = (romtype) => {
  return forskriftKontroller[romtype] || [];
};

export const erObligatoriskKontroll = (romtype, kontrollId) => {
  const kontroller = forskriftKontroller[romtype] || [];
  const kontroll = kontroller.find(k => k.id === kontrollId);
  return kontroll?.obligatorisk || false;
};
